// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._37u9pNJzZ6UKiKLV-K2JHU {\r\n    height: 0;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n    transition: height 0.25s ease-in-out, min-height 0.25s ease-in-out;\r\n}\r\n", ""]);
// Exports
exports.locals = {
	"container": "_37u9pNJzZ6UKiKLV-K2JHU"
};
module.exports = exports;
